// Modale de création d'un nouveau groupe.
// Étapes : saisir un nom, cocher au moins un partenaire, valider.
// Réutilise le style .mens-modal-* pour rester cohérent avec les autres modales.
import React, { useEffect, useState } from "react";
import { createGroup, getAllPartners } from "../services/authService";

export default function CreateGroupModal({ onClose, onCreated }) {
	const [nom, setNom] = useState("");
	const [partners, setPartners] = useState([]);
	const [selectedIds, setSelectedIds] = useState(new Set());
	const [loading, setLoading] = useState(true);
	const [creating, setCreating] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		(async () => {
			const result = await getAllPartners();
			setLoading(false);
			if (result.success) setPartners(result.partners);
			else setError(result.error || "Erreur");
		})();
	}, []);

	const toggleMember = (id) => {
		const next = new Set(selectedIds);
		if (next.has(id)) next.delete(id);
		else next.add(id);
		setSelectedIds(next);
	};

	const handleCreate = async () => {
		setError("");
		if (!nom.trim()) {
			setError("Le nom du groupe est requis.");
			return;
		}
		if (selectedIds.size === 0) {
			setError("Sélectionne au moins un membre.");
			return;
		}
		setCreating(true);
		const result = await createGroup(nom.trim(), Array.from(selectedIds));
		setCreating(false);
		if (result.success) {
			onCreated?.(result.idGroup);
		} else {
			setError(result.error || "Erreur lors de la création.");
		}
	};

	return (
		<div className="mens-modal-overlay" onClick={onClose}>
			<div className="mens-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460 }}>
				<div className="mens-modal-header">
					<h3>Nouveau groupe</h3>
					<button className="mens-modal-close" onClick={onClose}>×</button>
				</div>

				<label className="mens-modal-label">
					Nom du groupe
					<input
						type="text"
						className="mens-modal-date"
						value={nom}
						onChange={(e) => setNom(e.target.value)}
						maxLength={100}
						placeholder="Team musculation"
						autoFocus
					/>
				</label>

				<div className="group-settings-section">
					<span className="group-settings-label">Membres à ajouter</span>
					{loading ? (
						<p style={{ color: "var(--ink-soft)" }}>Chargement des partenaires...</p>
					) : partners.length === 0 ? (
						<p style={{ color: "var(--ink-soft)" }}>
							Tu n'as pas encore de partenaires. Ajoute-en depuis l'app avant de créer un groupe.
						</p>
					) : (
						<ul className="group-settings-members">
							{partners.map((p) => {
								const selected = selectedIds.has(p.id);
								return (
									<li
										key={p.id}
										className={`group-settings-member selectable ${selected ? "selected" : ""}`}
										onClick={() => toggleMember(p.id)}
									>
										<span className="group-settings-member-name">{p.prenom} {p.nom}</span>
										<span className="group-settings-checkbox">
											{selected ? "✓" : ""}
										</span>
									</li>
								);
							})}
						</ul>
					)}
				</div>

				{error && <div className="mens-modal-error">{error}</div>}

				<div className="mens-modal-actions">
					<button className="mens-btn ghost" onClick={onClose} disabled={creating}>Annuler</button>
					<button
						className="mens-btn primary"
						onClick={handleCreate}
						disabled={creating || !nom.trim() || selectedIds.size === 0}
					>
						{creating ? "Création..." : "Créer le groupe"}
					</button>
				</div>
			</div>
		</div>
	);
}
